import { render } from "./XIconSolidWrench.vue?vue&type=template&id=299da540"
import script from "./XIconSolidWrench.vue?vue&type=script&lang=js"
export * from "./XIconSolidWrench.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidWrench.vue"]])

export default __exports__